<main class="w-full">
  <!-- 첫 번째 섹션: 참가신청 절차 및 신청서 접수 -->
  <section class="flex flex-col w-full max-w-6xl mx-auto py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
    <!-- 타이틀 -->
    <div class="text-center flex flex-col gap-4">
      <p class="sb-aggro text-zinc-500 text-sm lg:text-base">Registration Guide plan</p>
      <h1 class="text-2xl lg:text-4xl text-zinc-800">참가신청 안내</h1>
    </div>

    <div class="flex flex-col gap-6">
      <!-- PC: 가로 배치, 모바일: 세로 배치 -->
      <div class="flex flex-col lg:flex-row gap-6 lg:gap-10">
        <div class="flex flex-col gap-3 justify-center lg:min-w-75">
          <h1 class="text-zinc-800 text-xl lg:text-3xl">참가 신청 절차 및 <br class="hidden lg:flex" />신청서 접수</h1>
          <p class="text-zinc-400 font-medium text-sm lg:text-base">
            참가신청서(소정 양식) 작성 및
            <br class="hidden lg:flex" />사업자등록증 사본 접수
          </p>
        </div>

        <!-- PC: 가로 배치, 모바일: 세로 배치 -->
        <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 w-full">
          <div class="flex-1 flex flex-col lg:flex-col bg-zinc-50 rounded-2xl pt-10 pb-8 px-8">
            <div class="flex items-end lg:items-start justify-between lg:flex-col lg:gap-6">
              <div class="flex flex-col gap-2.5">
                <p class="sb-aggro text-zinc-800 font-light">FAX</p>
                <p class="sb-aggro text-lg text-zinc-800">062-371-3512</p>
              </div>
              <img src="/event/fax.svg" alt="fax icon" class="w-11 h-10 lg:ml-auto" />
            </div>
          </div>

          <div class="flex-1 flex flex-col lg:flex-col bg-zinc-50 rounded-2xl pt-10 pb-8 px-8">
            <div class="flex items-end lg:items-start justify-between lg:flex-col lg:gap-6">
              <div class="flex flex-col gap-2.5">
                <p class="sb-aggro text-zinc-800 font-light">E-mail</p>
                <p class="sb-aggro text-lg text-zinc-800">{{ email()?.value || 'Expobuy@naver.com' }}</p>
              </div>
              <img src="/event/email.svg" alt="email icon" class="w-11 h-10 lg:ml-auto" />
            </div>
          </div>
        </div>
      </div>

      <!-- 참가 신청 절차 -->
      <div class="bg-zinc-50 p-6 lg:p-15 flex flex-col gap-4 lg:gap-6 items-center rounded-2xl">
        <h1 class="text-zinc-800 font-light">참가 신청 절차</h1>

        <!-- 모바일: 스텝별 카드, PC: 이미지 -->
        <div class="hidden lg:block w-full">
          <img src="/event/progress.svg" alt="참가 신청 절차" class="w-full" />
        </div>

        <!-- 모바일 버전 스텝 -->
        <div class="flex lg:hidden flex-col w-full">
          <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
            <img src="/event/step-1.svg" alt="step icon" class="size-5" />
            <div class="flex-1">
              <p class="text-zinc-800 sb-aggro text-sm font-light">참가신청서 작성</p>
            </div>
            <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 1</span>
          </div>

          <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

          <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
            <img src="/event/step-2.svg" alt="step icon" class="size-5" />
            <div class="flex-1">
              <p class="text-zinc-800 sb-aggro text-sm font-light">참가비 50% 납부</p>
            </div>
            <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 2</span>
          </div>

          <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

          <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
            <img src="/event/step-3.svg" alt="step icon" class="size-5" />
            <div class="flex-1">
              <p class="text-zinc-800 sb-aggro text-sm font-light">부스신청 선정</p>
            </div>
            <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 3</span>
          </div>

          <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

          <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
            <img src="/event/step-4.svg" alt="step icon" class="size-5" />
            <div class="flex-1">
              <p class="text-zinc-800 sb-aggro text-sm font-light">참가비 잔금 납부</p>
            </div>
            <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 4</span>
          </div>

          <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

          <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
            <img src="/event/step-5.svg" alt="step icon" class="size-5" />
            <div class="flex-1">
              <p class="text-zinc-800 sb-aggro text-sm font-light">전시회 배정</p>
            </div>
            <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 5</span>
          </div>

          <app-icon name="material-symbols:keyboard-arrow-down-rounded" class="text-zinc-200 size-6! mx-auto" />

          <div class="bg-white py-2 px-5 rounded-full flex items-center gap-3">
            <img src="/event/step-6.svg" alt="step icon" class="size-5" />
            <div class="flex-1">
              <p class="text-zinc-800 sb-aggro text-sm font-light">부스 입주 진행</p>
            </div>
            <span class="sb-aggro font-light text-zinc-400 text-xs">STEP 6</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 두 번째 섹션: 참가비 납부 안내 -->
  <section class="flex flex-col w-full bg-zinc-50 py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
    <div class="w-full max-w-6xl mx-auto">
      <div class="flex flex-col lg:flex-row gap-6 lg:gap-10 lg:max-h-180">
        <!-- 왼쪽: 고정 영역 (데스크톱에서만 sticky) -->
        <div class="flex flex-col gap-3 justify-start lg:min-w-75 lg:sticky lg:top-20 lg:self-start">
          <h1 class="text-zinc-800 text-xl lg:text-3xl">참가비 납부 안내</h1>
          <p class="text-zinc-400 font-medium text-sm lg:text-base">
            계약 체결 후 3일 이내 계약금 50% 납부, <br class="hidden lg:flex" />
            조기 신청 할인기간 조정 중
          </p>
        </div>

        <!-- 오른쪽: 스크롤 영역 (데스크톱에서만) -->
        <div class="flex flex-col w-full gap-8 lg:gap-15 lg:max-h-180 lg:overflow-y-auto lg:pr-4">
          <!-- 납부 안내 -->
          <div class="flex flex-col gap-4">
            <h1 class="text-lg lg:text-xl text-zinc-800">납부 안내</h1>
            <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-4 lg:p-8">
              <!-- 일반 부스 -->
              <div class="flex flex-col lg:flex-row gap-4 lg:gap-0">
                <div class="flex flex-1 gap-4 lg:gap-6">
                  <img src="/event/normal-booth.svg" alt="일반 부스" class="size-12 lg:size-15" />
                  <div class="flex flex-col gap-2 lg:gap-3">
                    <p class="sb-aggro text-base lg:text-lg text-zinc-800">일반 부스</p>
                    <p class="sb-aggro text-xs lg:text-sm font-light text-zinc-400">1Booth (3mx3m=9㎡)</p>
                  </div>
                </div>
                <div class="flex flex-1 gap-6 lg:gap-10">
                  <div class="flex flex-1 flex-col gap-2.5">
                    <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">독립부스 금액</p>
                    <p class="sb-aggro text-zinc-800 text-sm lg:text-base">1,800,000원</p>
                  </div>
                  <div class="flex flex-1 flex-col gap-2.5">
                    <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">조립부스 금액</p>
                    <p class="sb-aggro text-zinc-800 text-sm lg:text-base">2,200,000원</p>
                  </div>
                </div>
              </div>

              <div class="w-full h-px bg-zinc-200"></div>

              <!-- 코너 부스 -->
              <!-- <div class="flex flex-col lg:flex-row gap-4 lg:gap-0">
                <div class="flex flex-1 gap-4 lg:gap-6">
                  <img src="/event/corner-booth.svg" alt="코너 부스" class="size-12 lg:size-15" />
                  <div class="flex flex-col gap-2 lg:gap-3">
                    <p class="sb-aggro text-base lg:text-lg text-zinc-800">코너 부스</p>
                    <p class="sb-aggro text-xs lg:text-sm font-light text-zinc-400">1Booth (3mx3m=9㎡)</p>
                  </div>
                </div>
                <div class="flex flex-1 gap-6 lg:gap-10">
                  <div class="flex flex-1 flex-col gap-2.5">
                    <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">독립부스 금액</p>
                    <p class="sb-aggro text-zinc-800 text-sm lg:text-base">2,000,000원</p>
                  </div>
                  <div class="flex flex-1 flex-col gap-2.5">
                    <p class="sb-aggro font-light text-zinc-800 text-sm lg:text-base">조립부스 금액</p>
                    <p class="sb-aggro text-zinc-800 text-sm lg:text-base">2,500,000원</p>
                  </div>
                </div>
              </div>

              <div class="w-full h-px bg-zinc-200"></div> -->

              <div class="flex gap-1 items-center">
                <app-icon name="material-symbols:check-circle-rounded" class="text-zinc-300 size-5!" />
                <p class="sb-aggro text-zinc-600 font-light text-sm lg:text-base">입금 후 계약 체결</p>
              </div>
            </div>
            <ul class="list-disc list-inside text-zinc-400 text-sm space-y-1 px-2">
              <li class="text-primary-500">독립부스 기본 : 기본 2부스 이상 신청</li>
              <li>기술지원 비용은 별도(전기, 전화, 인터넷, 급/배수, 압축공기 등)</li>
              <li>입금 시 반드시 회사명을 기재해 주십시오.</li>
            </ul>
          </div>

          <!-- 납부 방법 -->
          <div class="flex flex-col gap-4">
            <h1 class="text-lg lg:text-xl text-zinc-800">납부 방법</h1>
            <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-4 lg:p-8">
              <div class="flex flex-col gap-2.5">
                <p class="text-zinc-800 sb-aggro font-light text-sm lg:text-base">계약금</p>
                <div class="flex flex-col lg:flex-row lg:justify-between lg:items-baseline gap-1 lg:gap-0">
                  <p class="text-zinc-800 sb-aggro text-base lg:text-lg">참가비 총액의 50%</p>
                  <p class="text-zinc-500 sb-aggro font-light text-xs lg:text-base">참가신청서 제출 후 즉시 납부</p>
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-4 lg:p-8">
              <div class="flex flex-col gap-2.5">
                <p class="text-zinc-800 sb-aggro font-light text-sm lg:text-base">잔금</p>
                <div class="flex flex-col lg:flex-row lg:justify-between lg:items-baseline gap-1 lg:gap-0">
                  <p class="text-zinc-800 sb-aggro text-base lg:text-lg">지불한 계약금 외 잔액</p>
                  <p class="text-zinc-500 sb-aggro font-light text-xs lg:text-base">행사 45일 전 납부</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 온라인 납부 계좌 -->
          <div class="flex flex-col gap-4">
            <h1 class="text-lg lg:text-xl text-zinc-800">온라인 납부 계좌</h1>
            <div class="flex flex-col lg:flex-row gap-4 lg:gap-10 bg-zinc-100 rounded-2xl p-6 lg:p-8 items-center">
              <div class="w-full lg:w-30 mr-auto flex items-center">
                <p class="sb-aggro text-zinc-800 text-lg lg:text-xl font-light leading-tight break-keep">
                  {{ paymentAccount().bankName }}
                </p>
              </div>
              <div class="flex flex-col lg:flex-row gap-3 lg:gap-6 lg:mx-auto w-full lg:w-auto">
                <div class="flex gap-2">
                  <p class="text-zinc-400 font-medium text-sm lg:text-base">계좌번호</p>
                  <p class="text-zinc-800 font-medium text-sm lg:text-base">{{ paymentAccount().accountNumber }}</p>
                </div>
                <div class="flex gap-2">
                  <p class="text-zinc-400 font-medium text-sm lg:text-base">예금주</p>
                  <p class="text-zinc-800 font-medium text-sm lg:text-base">{{ paymentAccount().accountHolder }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 세 번째 섹션: 전시 부스 유형 및 규격 안내 -->
  <section class="flex flex-col w-full max-w-6xl mx-auto py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
    <div class="flex flex-col lg:flex-row gap-6 lg:gap-10">
      <div class="flex flex-col gap-3 justify-start lg:min-w-75">
        <h1 class="text-zinc-800 text-xl lg:text-3xl">전시 부스 및 제공 내역</h1>
        <p class="text-zinc-400 font-medium text-sm lg:text-base">
          계약 체결 후 3일 이내 계약금 50% 납부,
          <br class="hidden lg:flex" />조기 신청 할인기간 조정 중
        </p>
      </div>

      <div class="flex flex-col gap-3 lg:gap-4 w-full">
        <h1 class="text-lg lg:text-xl text-zinc-800">전시 부스 유형 및 규격 안내</h1>

        <!-- 부스 규격 -->
        <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-3">
          <div class="bg-white p-6 lg:p-8 rounded-sm">
            <div class="flex gap-4 lg:gap-6 items-center">
              <img src="/event/size.svg" alt="부스 규격" class="size-12 lg:size-15" />
              <div class="flex flex-col gap-2">
                <p class="sb-aggro text-base lg:text-lg text-zinc-800">부스 규격</p>
                <p class="text-xs lg:text-sm text-zinc-400">3m x 3m = 9㎡ (2.7평)</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 조립부스 -->
        <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-3">
          <div class="bg-white p-6 lg:p-8 rounded-sm">
            <div class="flex gap-4 lg:gap-6 items-center">
              <img src="/event/diy.svg" alt="조립부스" class="size-12 lg:size-15" />
              <div class="flex flex-col gap-2">
                <p class="sb-aggro text-base lg:text-lg text-zinc-800">조립부스</p>
                <p class="text-zinc-800 font-medium text-sm lg:text-base">
                  전시자의 편의를 도모하기 위하여 주최자가 조립식으로 된 부스 장치를 일괄적으로 시공하여 주는 부스
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 독립부스 -->
        <div class="flex flex-col gap-5 bg-zinc-100 rounded-2xl p-3">
          <div class="bg-white flex flex-col gap-4 p-6 lg:p-8 rounded-sm">
            <div class="flex gap-4 lg:gap-6 items-start">
              <img src="/event/private.svg" alt="독립부스" class="size-12 lg:size-15" />
              <div class="flex flex-col gap-2">
                <p class="sb-aggro text-base lg:text-lg text-zinc-800">독립부스</p>
                <p class="text-zinc-800 font-medium text-sm lg:text-base">
                  전시자가 주최자로부터 전시 면적만 제공받아 출품업체가 지정 용역업체를 선정하여 전시 장치 및 장식을
                  자체적으로 설치
                </p>
              </div>
            </div>
            <div class="w-full h-px bg-zinc-200"></div>
            <ul class="list-disc list-inside text-zinc-400 text-sm space-y-1 px-2">
              <li>독립부스는 최소 신청 단위는 2개 부스임.</li>
              <li>시설 구조물의 높이는 전시장 바닥으로부터 4m를 초과할 수 없음.</li>
              <li>독립부스 출품업체는 장치 공사 시 도면을 제출하여 주최측의 승인을 받아 시공해야 함.</li>
              <li>조명을 설치할 경우 반드시 전기를 추가 신청하여야 함.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 밀리언 전시 부스 제공 내역 -->
    <div class="bg-zinc-50 p-6 lg:p-10 flex flex-col lg:flex-row gap-6 lg:gap-14 items-center rounded-2xl">
      <img src="/event/booth-image.svg" alt="부스 이미지" class="w-full lg:w-full lg:max-w-sm" />
      <div class="flex flex-col gap-4 w-full">
        <p class="sb-aggro text-xl lg:text-2xl text-zinc-800">전시 부스 제공 내역</p>
        <div class="w-full h-px bg-zinc-200"></div>
        <div class="flex flex-col gap-3">
          <div class="flex">
            <div class="w-24 lg:w-32 font-medium text-zinc-400 text-sm lg:text-base">부스크기</div>
            <div class="flex-1 text-zinc-800 font-medium text-sm lg:text-base">가로 세로 각각 3m (2.7평)</div>
          </div>

          <div class="flex">
            <div class="w-24 lg:w-32 font-medium text-zinc-400 text-sm lg:text-base">상호간판</div>
            <div class="flex-1 text-zinc-800 font-medium text-sm lg:text-base">
              상호 간판 및 부스번호판 각 1개 (참가업체용 국문, 영문 함께 표기)
            </div>
          </div>

          <div class="flex">
            <div class="w-24 lg:w-32 font-medium text-zinc-400 text-sm lg:text-base">조명</div>
            <div class="flex-1 text-zinc-800 font-medium text-sm lg:text-base">
              형광등 1개(40W), 스포트라이트 2개(100W), 전기 콘센트(2구/220V 1개) 기본 1KW 제공(더 추가 이용 시 별도 신청
              요망.
            </div>
          </div>

          <div class="flex">
            <div class="w-24 lg:w-32 font-medium text-zinc-400 text-sm lg:text-base">바닥</div>
            <div class="flex-1 text-zinc-800 font-medium text-sm lg:text-base">파이텍스로 시공(방염 처리)</div>
          </div>

          <div class="flex">
            <div class="w-24 lg:w-32 font-medium text-zinc-400 text-sm lg:text-base">집기</div>
            <div class="flex-1 text-zinc-800 font-medium text-sm lg:text-base">안내 데스크 1개 + 의자 1개</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
